import Vue from 'vue'
const state = {
  page: 1,
  formData: {
    testName: '',
    testTime: ''
  },
  questionList: [], // 题目列表
  questionIndex: 0, // 题目下标
  questionPage: 1, // 题目page
  totalPages: 1, // 题目总页数
  initialSwipeIndex: 0 // 答题卡位置索引
}

const mutations = {
  changeCurrentPage: (state, n) => {
    state.page = n;
  },
  cacheFormData: (state, n) => {
    state.formData = n;
  },
  changeQuestionList: (state, n) => {
    state.questionList = n;
  },
  changequestionIndex: (state, n) => {
    state.questionIndex = n;
  },
  addQuestionIndex: (state, n) => {
    state.questionIndex = state.questionIndex + 1;
  },
  minusQuestionIndex: (state, n) => {
    state.questionIndex = state.questionIndex - 1;
  },
  addQuestionPage (state, n) {
    state.questionPage = state.questionPage + 1;
  },
  updateQuestionPage (state, n) {
    state.questionPage = n;
  },
  totalPages (state, n) {
    state.totalPages = n;
  },
  initialSwipeIndex (state, n) {
    state.initialSwipeIndex = n;
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/exam.js